<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="4"></Aide>

        <h3 class="titreSolu text-center">Gestion type</h3>
        <b-collapse id="collapse-2">
            <h4 class="text-center">Créer un type</h4>
            <div>
                <div class="row" style="margin-top: 75px;">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Intitulé
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="intituleMachineType" name="intituleMachineType" placeholder="Intitulé">
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Niveau
                    </div>
                    <div class="col-7">
                        <select v-model="niveauMachineType" class="form-control" name="niveauMachineType">
                            <option v-for="(lNiv, key) in listNiveau" :key="key"
                                    v-bind:value="lNiv">{{ lNiv }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Afficher champs batterie %
                    </div>
                    <div class="col-7">
                        <select v-model="chargeMachineType" class="form-control" name="chargeMachineType">
                            <option v-for="(rep, key) in listReponse" :key="key"
                                    v-bind:value="key">{{ rep }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Afficher champs horamètre
                    </div>
                    <div class="col-7">
                        <select v-model="horametreMachineType" class="form-control" name="horametreMachineType">
                            <option v-for="(rep, key) in listReponse" :key="key"
                                    v-bind:value="key">{{ rep }}
                            </option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="addMachineType()" >
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        </b-collapse>
        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>

        <div>
            <h4 class="text-center">Liste des types existants</h4>
            <div class="row">
                <div class="col-12 text-right">
                    <button v-b-toggle="'collapse-2'" class="btn btn-primary"><i class="fa-solid fa-plus"></i> Ajout machine</button>
                </div>
            </div>
            <table  v-if="listMachineType.length>0" class="table table-striped table-bordered " >
                <tr>
                    <th class="thtab">Intitulé</th>
                    <th class="thtab">Niveau</th>
                    <th class="thtab">Batterie</th>
                    <th class="thtab">Horamètre</th>
                    <th class="thtab"></th>
                    <th class="thtab"></th>
                </tr>
                <tr v-for="(machineType, key) in listMachineType" :key="key" >
                    <td>
                        <span v-if="keyUpd!=key">{{machineType.intitule}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="intituleMachineTypeUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                                {{machineType.niveau}}
                        </span>
                        <select v-if="keyUpd==key" v-model="niveauMachineTypeUpd" class="form-control" name="niveauMachineTypeUpd">
                            <option v-for="(lNiv, key) in listNiveau" :key="key"
                                    v-bind:value="key">{{ lNiv }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                                {{listReponse[machineType.charge]}}
                        </span>
                        <select v-if="keyUpd==key" v-model="chargeMachineTypeUpd" class="form-control" name="chargeMachineTypeUpd">
                            <option v-for="(rep, key) in listReponse" :key="key"
                                    v-bind:value="key">{{ rep }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                                {{listReponse[machineType.horametre]}}
                        </span>
                        <select v-if="keyUpd==key" v-model="horametreMachineTypeUpd" class="form-control" name="horametreMachineTypeUpd">
                            <option v-for="(rep, key) in listReponse" :key="key"
                                    v-bind:value="key">{{ rep }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="keyUpd!=key" class="fa-solid fa-pen-to-square fa-2x text-warning" @click="beforeUpdate(key)"></i>
                        <i v-if="keyUpd==key" class="fa-solid fa-check fa-2x text-success" @click="valideUpdate(key)"></i>
                        &nbsp;
                        <i v-if="keyUpd==key" class="fa-solid fa-xmark fa-2x text-danger" @click="cancel()"></i>
                    </td>
                    <td>
                        <i class="fa-regular fa-trash-can fa-2x text-danger" @click="deleteObjet(key)"></i>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row">
            <div class="col-12 text-center text-info">
                {{listMachineType.length}} entité(s)
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "MachineType",
        props: ['token', 'site', 'user', 'racine', 'userId','systemeClient'],
        data() {
            return {
                intituleMachineType:'',typeMachine:1,errors:[],msgs:[],listNiveau:{1:1,2:2},listReponse:{1:"Oui",0:"Non"},
                listMachineType:[], intituleMachineTypeUpd:'',keyUpd:null,checkValideMachin:true,
                niveauMachineType:1,horametreMachineType:1,chargeMachineType:1,
                niveauMachineTypeUpd:1,horametreMachineTypeUpd:1,chargeMachineTypeUpd:1,
            };
        },
        methods:
            {
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                addMachineType()
                {
                    this.errors = [];
                    this.msgs = [];
                    if(this.intituleMachineType!='') {
                        console.log(this.intituleMachineType)




                        fetch(this.racine + this.site + 'api/machine_types', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                            body: "{\"intitule\":\"" + this.intituleMachineType + "\"," +
                            "\"niveau\": " + this.niveauMachineType + "," +
                            "\"horametre\": " + this.horametreMachineType + "," +
                            "\"charge\": " + this.chargeMachineType + "," +
                            "\"systemeClient\": \"" + this.systemeClient + "\"" +
                            "}"
                        }).then(response => response.json())
                            .then(json => {
                                console.log(json);
                                if (json['@type'] == "hydra:Error") {
                                    this.errors.push("Cet intitulé est déjà utilisé.")
                                    this.popup()
                                }
                                else if (json['id'] > 0) {
                                    this.msgs.push("Ajout du type effectué.")
                                    this.getMachineTypes()
                                    this.intituleMachineType = ''
                                    this.popup()
                                }
                                else {
                                    this.errors.push("Un problème inconnu s'est produit.")
                                    this.popup()
                                }
                            })
                    }
                    else
                    {
                        this.errors.push("Vous devez remplir l'intitulé.");
                    }


                },
                getMachineTypes()
                {
                    fetch(this.racine + this.site + 'api/machine_types?systemeClient='+this.systemeClient, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listMachineType = json['hydra:member']
                            }
                        })
                    })
                },
                beforeUpdate(keyMachine)
                {
                    //on charge les données de la ligne dans les variables pour l'update
                    this.keyUpd = keyMachine
                    this.intituleMachineTypeUpd = this.listMachineType[this.keyUpd].intitule
                    this.niveauMachineTypeUpd = this.listMachineType[this.keyUpd].niveau
                    this.horametreMachineTypeUpd = this.listMachineType[this.keyUpd].horametre
                    this.chargeMachineTypeUpd = this.listMachineType[this.keyUpd].charge
                },
                valideUpdate(key)
                {
                    this.errors = [];
                    this.msgs = [];
                    if(this.intituleMachineTypeUpd!='') {
                        this.$confirm(
                            {
                                title: 'Etes vous sûr?',
                                message: 'Etes vous sur de vouloir modifier ' + this.listMachineType[key].intitule + '?',
                                button: {
                                    yes: 'Oui',
                                    no: 'Non'
                                },
                                callback: confirm => {
                                    if (confirm == true) {
                                        fetch(this.racine + this.site + 'api/machine_types/'+this.listMachineType[key].id, {
                                            method: 'PUT',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': 'Bearer ' + this.token
                                            },
                                            body: "{\"intitule\":\"" + this.intituleMachineTypeUpd + "\"," +
                                            "\"niveau\": " + this.niveauMachineTypeUpd + "," +
                                            "\"horametre\": " + this.horametreMachineTypeUpd + "," +
                                            "\"systemeClient\": \"" + this.systemeClient + "\"," +
                                            "\"charge\": " + this.chargeMachineTypeUpd + "" +
                                            "}"
                                        }).then(response => response.json())
                                            .then(json => {
                                                console.log(json);
                                                if (json['@type'] == "hydra:Error") {
                                                    this.errors.push("Cet intitulé est déjà utilisé.")
                                                    this.popup()
                                                }
                                                else if (json['id'] > 0) {
                                                    this.msgs.push("Modification du type effectué.")
                                                    this.getMachineTypes()
                                                    this.intituleMachineType = ''
                                                    this.popup()
                                                    this.keyUpd = null
                                                }
                                                else {
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                    this.popup()
                                                }
                                            })
                                    }
                                }
                            }
                        )
                    }
                    else
                    {
                        this.errors.push("Vous devez remplir l'intitulé.");
                    }
                },
                popup()
                {
                    this.$bvModal.show('modalInfo')
                    setTimeout(() => {//on laisse le message quelques instants
                        this.$bvModal.hide('modalInfo')
                        this.errors = []
                        this.msgs = []
                    }, 2000)
                },
                cancel()
                {
                    this.keyUpd = null
                },
                deleteObjet(key)
                {
                    var self = this
                    this.$confirm(
                        {
                            title: 'Etes vous sûr?',
                            message: 'Etes vous sur de vouloir supprimer ' + this.listMachineType[key].intitule + '?',
                            button: {
                                yes: 'Oui',
                                no: 'Non'
                            },
                            callback: confirm => {
                                if (confirm == true) {
                                    fetch(this.racine + this.site + 'api/machine_types/'+this.listMachineType[key].id, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        }
                                    }).then(function(response) {
                                        console.log(response.ok)
                                        if(response.ok == true)
                                        {
                                            self.getMachineTypes()
                                            self.keyUpd = null
                                            self.msgs.push("Suppression du type effectuée.")
                                            self.popup()
                                        }
                                        else {
                                            self.errors.push("Un problème inconnu s'est produit.")
                                            self.popup()
                                        }

                                    })
                                }
                            }
                        }
                    )

                },

            },
        mounted() {
            this.getMachineTypes()

        },
        created() {
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>